module.exports = __webpack_public_path__ + "static/2_1_search-1_EL-9d708b690f5d3133ec9bc10e8ce9083b.svg";